import { useState } from 'react';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './index.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Home from './pages/home/Home';
import SellMobile from './pages/sell-mobile/SellMobile';
import BuyMobile from './pages/buy-mobile/BuyMobile';
import PurchaseOrders from './pages/purchase-orders/PurchaseOrders';
import Android from './pages/buy-mobile/Android';
import ProductDetail from './pages/buy-mobile/ProductDetail';



import RepairMobile from './pages/repair-mobile/RepairMobile';
import Contact from './pages/contact/Contact';
import Layout from './components/layout/Layout';
import NoPage from './pages/no-page/NoPage';
import { HelmetProvider } from 'react-helmet-async';
import Model from './pages/models/Model';
import ModelDetail from './pages/model-details/ModelDetail';
import Option from './pages/options/Option';
import SalesOrders from './pages/sales-orders/SalesOrders';
import SalesOrdersDetail from './pages/sales-order-detail/SalesOrderDetail';
import Exactvalue from './pages/exactvalue/Exactvalue';
import Sellnow from './pages/sell-now/Sellnow';
import EditProfile from './pages/edit-profile/EditProfile';
import Response from './pages/response/response';
import SearchResult from './pages/search-result/SearchResult';
import About from './pages/about/About';
import Faq from './pages/faq/Faq';
import Blogs from './pages/blogs/Blogs';
import SellOldPhoneBestPrice2025 from './pages/blogs/SellOldPhoneBestPrice2025';
import WhyAppleIphonesHaveHigherResaleValueThanAndroid from './pages/blogs/WhyAppleIphonesHaveHigherResaleValueThanAndroid';
import SellUsedPhoneHyderabad from './pages/blogs/SellUsedPhoneHyderabad';
import HyderabadCashifyAlternativesQuickCashDeals from './pages/blogs/HyderabadCashifyAlternativesQuickCashDeals';
import SellYourOldPhoneForCash from './pages/blogs/SellYourOldPhoneForCash';
import IsItSafeToSellPhonesOnline from './pages/blogs/IsItSafeToSellPhonesOnline';
import WorriedAboutScams from './pages/blogs/WorriedAboutScams';

import InstantCashForMobileInHyderabad from './pages/blogs/InstantCashForMobileInHyderabad';
import SpotFakeMobilePhonesOnlineHyderabad from './pages/blogs/SpotFakeMobilePhonesOnlineHyderabad';

import HowToSafelySellOldGadgetsAndProtectYourData from './pages/blogs/HowToSafelySellOldGadgetsAndProtectYourData';
import HowToCheckYourPhoneResaleValueInHyderabad from './pages/blogs/HowToCheckYourPhoneResaleValueInHyderabad';
import SellYourOldPhoneOnline from './pages/blogs/SellYourOldPhoneOnline';
import SellYourSmartphoneOnline from './pages/blogs/SellYourSmartphoneOnline';
import SellYourUsedAndroidPhone from './pages/blogs/SellYourUsedAndroidPhone';
import SellYourAndroidPhoneForBestPrice from './pages/blogs/SellYourAndroidPhoneForBestPrice';
import BestPhoneSaleOnlinePlatform2025 from './pages/blogs/BestPhoneSaleOnlinePlatform2025';




import PrivacyPolicy from './pages/privacy-policy/PrivacyPolicy';
import DeviceReports from './pages/device-report/DeviceReport';
import { useUser } from "./UserContext";
import Requote from './pages/requote/Requote';
import Reexactvalue from './pages/reexactvalue/Reexactvalue';
import RouteListener from './RouteListener';
import PartnerForm from './pages/partner-form/PartnerForm';

function App() {
  const [userInfo, setUserInfo] = useState(JSON.parse(localStorage.getItem('userData')));

  const { user, logoutUser } = useUser();
  return (
    <>
      <HelmetProvider>
        <RouteListener />
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="/:city?" element={<Home />} />
            <Route path="/:city?/sell-mobile" element={<SellMobile />} />
            <Route path="/:city?/sell-mobile/:slug" element={<Model />} />
            <Route path="/:city?/sell-mobile/:brand/:model" element={<ModelDetail />} />

            <Route path="/:city?/buy-mobile" element={<BuyMobile />} />
            <Route path="/:city?/buy-mobile/:slug" element={<Android />} />
            <Route path="/:city?/buy-mobile/:brand/:model" element={<ProductDetail />} />
            {/* <Route path="/:city?/android-phones" element={<Android />} />
            <Route path="/:city?/product-detail" element={<ProductDetail />} /> */}


            <Route path="/:city?/purchase-orders" element={<PurchaseOrders />} />
            <Route path="/:city?/repair-mobile" element={<RepairMobile />} />
            <Route path="/:city?/contact" element={<Contact />} />
            <Route path="/:city?/options/:model/:variant" element={<Option />} />
            <Route path="/:city?/search-result/:search" element={<SearchResult />} />
            <Route path="/about" element={<About />} />
            <Route path="/faq" element={<Faq />} />
            <Route path="/blogs" element={<Blogs />} />
            <Route path="/sell-old-phone-best-price-2025" element={<SellOldPhoneBestPrice2025 />} />
            <Route path="/why-apple-iphones-have-higher-resale-value-than-android" element={<WhyAppleIphonesHaveHigherResaleValueThanAndroid />} />
            <Route path="/sell-used-phone-hyderabad" element={<SellUsedPhoneHyderabad />} />
            <Route path="/sell-phone-online-hyderabad-safe-cellcash" element={<WorriedAboutScams />} />
            <Route path="/instant-cash-for-mobile-hyderabad" element={<InstantCashForMobileInHyderabad />} />
            <Route path="/spot-fake-mobile-phones-online-hyderabad" element={<SpotFakeMobilePhonesOnlineHyderabad />} />
            <Route path="/how-to-safely-sell-old-gadgets-and-protect-your-data" element={<HowToSafelySellOldGadgetsAndProtectYourData />} />
            <Route path="/how-to-check-your-phone-resale-value-in-hyderabad" element={<HowToCheckYourPhoneResaleValueInHyderabad />} />


            <Route path="/hyderabad-cashify-alternatives-quick-cash-deals" element={<HyderabadCashifyAlternativesQuickCashDeals />} />

            <Route path="/sell-your-old-phone-for-cash" element={<SellYourOldPhoneForCash />} />
            <Route path="/is-it-safe-to-sell-phones-online" element={<IsItSafeToSellPhonesOnline />} />
            <Route path="/sell-your-old-phone-online" element={<SellYourOldPhoneOnline />} />
            <Route path="/sell-your-smartphone-online" element={<SellYourSmartphoneOnline />} />
            <Route path="/sell-your-used-android-phone" element={<SellYourUsedAndroidPhone />} />
            <Route path="/sell-your-android-phone-for-best-price" element={<SellYourAndroidPhoneForBestPrice />} />
            <Route path="/best-phone-sale-online-platform-2025" element={<BestPhoneSaleOnlinePlatform2025 />} />


            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/:city?/device-report/:ref_no" element={<DeviceReports />} />
            <Route path="/requote/:ref_no/:model/:variant" element={<Requote />} />
            <Route path="/:city?/reexact-value/:ref_no" element={<Reexactvalue />} />
            <Route path="/partner-form" element={<PartnerForm />} />
            <Route path="*" element={<NoPage />} />
            {
              user && <>
                <Route path="/editprofile" element={<EditProfile />} />
                <Route path="/response/:ref_no" element={<Response />} />
                <Route path="/sales-orders" element={<SalesOrders />} />
                <Route path="/sales-order-detail/:ref_no" element={<SalesOrdersDetail />} />
                <Route path="/:city?/exact-value" element={<Exactvalue />} />
                <Route path="/sell-now" element={<Sellnow />} />
              </>
            }



          </Route>
        </Routes>
      </HelmetProvider>
    </>
  )
}

export default App